export default __webpack_public_path__ + "static/media/addtoastadmin.05be51d7.svg";